module.exports = __webpack_public_path__ + "img/robot_3.9ca780fd.png";